<template>
  <div class="home">
    <!-- 六大指标指标卡 -->
    <hc-content />
    <!-- 趋势图 -->
    <hc-sale />
    <!-- 饼图和效率排行 -->
    <hc-pie />
    <!-- 最新设备告警组件 -->
    <hc-warning />
  </div>
</template>

<script setup>
import hcContent from "./components/contnet-item.vue";
import hcSale from "./components/sale.vue";
import hcPie from "./components/piechart.vue";
import hcWarning from "./components/warning.vue";
</script>

<style lang="less" scoped>
.home {
  background-color: #f4f5fa;
  width: 100%;
  overflow: auto;
  padding: 15px 20px 20px 20px;
  // border: 1px solid red;
}
</style>
